import { useBrandConfigContext } from '../../providers/BrandConfigContext/BrandConfigContext'

const AddToTrolleyButtonWrapper = ({ children }) => {
  const { FABLE_ATT } = useBrandConfigContext()

  const isFableATTEnabled = FABLE_ATT
  const [control, variant] = children

  // Return the variant component if FABLE_ATT is enabled, otherwise return the control component
  if (isFableATTEnabled) {
    return variant
  }
  return control
}

export default AddToTrolleyButtonWrapper
